import React from 'react';
import styles from './styles.module.scss';

const Header = () => {
  return (
    <div className={styles.header}>
      <span className={styles.text}>Craving Intensity</span>
      <span className={styles.item}>
        <span className={styles['icon-craving']} />
        <span>Non-Use</span>
      </span>
      <span className={styles.item}>
        <span className={styles['icon-used']} />
        <span>Used</span>
      </span>
    </div>
  );
};

export default Header;
